import React, {Component} from 'react';
import { Link } from 'components/ReactRouterDomLocalized';

import {t, dt} from 'l10n';
import {getReturnPath, getPaymentUrl} from 'utils/url';
import {formatExpirationDate} from 'utils/user';

import EditIcon from "components/icon/Edit"
import ExitIcon from "components/icon/Exit"

import paths from 'paths';

// todo: XXL status

export default function ModalMenuUserBlock(props) {
    let {currentUser, pm, logout, showDelete} = props;

    let pmMessagesCounter = "?";
    let pmMessagesHighlight = false;
    if (pm.status == "connected") {
        pmMessagesCounter = pm.counters.allowed_unread + pm.counters.requested_by_recipient;
        pmMessagesHighlight = pmMessagesCounter > 0;
    }

    // todo: replace logout onClick with connect'ed prop fn

    let returnPath = getReturnPath();
    return (
        <div className="userInfo">
            <p className="account">
                <span className="user-avatar">
                    <Link to={paths.member.path}><img src={currentUser.avatar_url} alt="" /></Link>
                </span>
                <Link to={paths.member.path} className="nick">
                    {currentUser.nick}
                </Link>
                <span className="icons-wrapper" >
                    <Link to={paths.member.path} className="profile-edit">
                        <EditIcon colorIndex="theme"/>
                    </Link>
                    <span className="logout" onClick={() => logout()}><ExitIcon colorIndex="theme"/></span>
                </span>
            </p>
            <div className="menu-userInfo">
                <p>
                    <span className={"number " + (currentUser.counters.count_notifications > 0 ? "highlight" : "")}>{currentUser.counters.count_notifications}</span>
                    <Link to={paths.memberNotificationList.path}>{dt('notifications', 'Notification services')}</Link>
                </p>
                <p>
                    <span className={"number " + (currentUser.counters.count_my_messages > 0 ? "highlight" : "")}>{currentUser.counters.count_my_messages}</span>
                    <Link to={paths.memberMessageListMessages.path}>{t('My messages')}</Link>
                </p>

                <p>
                    <span className={"number " + (pmMessagesHighlight ? "highlight" : "")}>{pmMessagesCounter}</span>
                    <Link to={paths.memberMessagePmConversations.path}>{t('Private messages')}</Link>
                </p>


                <p>
                    <span className={"number " + (currentUser.counters.count_my_guest_book > 0 ? "highlight" : "")}>{currentUser.counters.count_my_guest_book}</span>
                    <Link to={paths.memberGuestbook.path}>{t('My guest book')}</Link>
                </p>
                <p>
                    <span className="number">{currentUser.counters.count_black_users}</span>
                    <Link to={paths.memberBlackList.path}>{t('My black list')}</Link>
                </p>
                <p>
                    <span className={"number " + (currentUser.counters.count_my_following > 0 ? "highlight" : "")}>{currentUser.counters.count_my_following}</span>
                    <Link to={paths.memberFollowing.path}>{t('Followees')}</Link>
                </p>
                <p>
                    <span className="number">{currentUser.counters.amount_wallet}</span>
                    <Link to={paths.memberWallet.path}>{t('My wallet')}</Link>
                </p>
                <p>
                    <span className={"number " + (currentUser.counters.gift_count > 0 ? "highlight" : "")}>{currentUser.counters.gift_count}</span>
                    <Link to={paths.memberVirtualGifts.path}>{t('My virtual gifts')}</Link>
                </p>
                <p>
                    <Link to={paths.memberPaymentHistory.path}>{t('My membership')}</Link>
                </p>
                <div className="delete-account" onClick={showDelete}>{t('Delete my account')}</div>
            </div>
            <XXLStatusSubBlock currentUser={currentUser} returnPath={returnPath}/>
        </div>
    )
};

function XXLStatusSubBlock(props) {
    let {currentUser, returnPath} = props,
        isXXL = currentUser.isXXL();

    if (isXXL) {
        let expirationDate = formatExpirationDate(currentUser);

        return (
            <div className="functionl-block xxl">
                <div className="header"
                     dangerouslySetInnerHTML={{__html: dt('xxl', '<span class="XXL">XXL</span> Membership')}}/>
                {expirationDate && <p>{t('Expiration:')} {expirationDate}</p>}
                <nav>
                    <Link to={getPaymentUrl(returnPath)}>{t('Buy more XXL')}</Link>
                </nav>
                <div className={'visaIcon'}></div>
            </div>
        )
    } else {
        return (
            <div className="functionl-block free">
                <div className="header"
                     dangerouslySetInnerHTML={{__html: dt('xxl', '<span class="XXL">XXL</span> Membership')}}/>
                <p dangerouslySetInnerHTML={{__html: t('Single payment, without automatic&nbsp;rebilling. Immediate access')}}></p>
                <nav>
                    <Link to={getPaymentUrl(returnPath)}>{t('Access XXL features')}</Link>
                </nav>
                <div className={'visaIcon'}></div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuUserBlock.js